module.exports = __webpack_public_path__ + "img/tooltip_02-vallone-aure-wood-grigio-marrone.9350e30e.jpg";